module.exports = __webpack_public_path__ + "img/refresh.bd4796af.svg";